import { Routes, Route, Navigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import LangGuard from './LangGuard';
import Home from '@/pages/Home/Home';
import Content from '@/pages/Content/Content';
import Creditos from '@/pages/Creditos/Creditos';
import NotFound from '@/pages/NotFound/NotFound';

export default function AppRoutes() {
    const { i18n } = useTranslation();

    return (
        <Routes>
            <Route index element={<Navigate to={i18n.language} />} />
            <Route path="/:lang/*" element={<LangGuard />}>
                <Route index element={<Home />} />
                <Route path=":slug" element={<Content />} />
                <Route path="creditos" element={<Creditos />} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}
